import React, { useState } from "react";
import {
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoCreateOutline,
  IoTrashOutline,
  IoCloseOutline,
} from "react-icons/io5";
import "../../Dashboard/pages/pages.css"; // reuse previous styles

const TPractice = () => {
  const [courses, setCourses] = useState([
    {
      id: 1,
      title: "React Course",
      practiceSessions: [
        {
          id: 1,
          title: "React Quiz 1",
          date: "2026-03-20",
          description: "Multiple choice quiz",
        },
        {
          id: 2,
          title: "React Mini Project",
          date: "2026-03-22",
          description: "Build a small project",
        },
      ],
    },
    {
      id: 2,
      title: "Node Course",
      practiceSessions: [],
    },
  ]);

  const [expandedCourse, setExpandedCourse] = useState(null);

  // Modal state
  const [modalOpen, setModalOpen] = useState(false);
  const [currentCourseId, setCurrentCourseId] = useState(null);
  const [editingSession, setEditingSession] = useState(null);

  const [sessionForm, setSessionForm] = useState({
    title: "",
    date: "",
    description: "",
  });

  // ===============================
  // OPEN MODAL
  // ===============================
  const openAddSession = (courseId) => {
    setSessionForm({ title: "", date: "", description: "" });
    setCurrentCourseId(courseId);
    setEditingSession(null);
    setModalOpen(true);
  };

  const openEditSession = (courseId, session) => {
    setSessionForm({
      title: session.title,
      date: session.date,
      description: session.description,
    });
    setCurrentCourseId(courseId);
    setEditingSession(session);
    setModalOpen(true);
  };

  // ===============================
  // SAVE SESSION
  // ===============================
  const handleSaveSession = () => {
    if (!sessionForm.title.trim() || !sessionForm.date) return;

    const updatedCourses = courses.map((course) => {
      if (course.id !== currentCourseId) return course;

      // EDIT
      if (editingSession) {
        return {
          ...course,
          practiceSessions: course.practiceSessions.map((s) =>
            s.id === editingSession.id ? { ...s, ...sessionForm } : s,
          ),
        };
      }

      // ADD
      return {
        ...course,
        practiceSessions: [
          ...course.practiceSessions,
          { id: Date.now(), ...sessionForm },
        ],
      };
    });

    setCourses(updatedCourses);
    setModalOpen(false);
  };

  // ===============================
  // DELETE SESSION
  // ===============================
  const deleteSession = (courseId, sessionId) => {
    const updated = courses.map((course) =>
      course.id === courseId
        ? {
            ...course,
            practiceSessions: course.practiceSessions.filter(
              (s) => s.id !== sessionId,
            ),
          }
        : course,
    );
    setCourses(updated);
  };

  // ===============================
  // DELETE COURSE
  // ===============================
  const deleteCourse = (courseId) => {
    setCourses(courses.filter((c) => c.id !== courseId));
  };

  return (
    <div className="overview-container">
      <h2>Practice Dashboard</h2>

      <table className="lessons-table">
        <thead>
          <tr>
            <th>Course</th>
            <th>Total Sessions</th>
            <th>Practice Details</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((course) => (
            <React.Fragment key={course.id}>
              <tr>
                <td>{course.title}</td>
                <td>{course.practiceSessions.length}</td>

                <td>
                  {course.practiceSessions.length > 0 ? (
                    <button
                      className="lesson-btn"
                      onClick={() =>
                        setExpandedCourse(
                          expandedCourse === course.id ? null : course.id,
                        )
                      }
                    >
                      {expandedCourse === course.id ? (
                        <IoChevronUpOutline />
                      ) : (
                        <IoChevronDownOutline />
                      )}
                    </button>
                  ) : (
                    <span className="no-lessons">No Sessions</span>
                  )}
                </td>

                <td>
                  <button
                    className="delete-btn"
                    onClick={() => deleteCourse(course.id)}
                  >
                    <IoTrashOutline />
                  </button>
                  <button
                    className="lesson-btn"
                    onClick={() => openAddSession(course.id)}
                    style={{ marginLeft: "10px" }}
                  >
                    + Session
                  </button>
                </td>
              </tr>

              {/* Expanded Practice Sessions Table */}
              {expandedCourse === course.id &&
                course.practiceSessions.length > 0 && (
                  <tr>
                    <td colSpan="4">
                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Title</th>
                            <th>Date</th>
                            <th>Description</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {course.practiceSessions.map((session, idx) => (
                            <tr key={session.id}>
                              <td>{idx + 1}</td>
                              <td>{session.title}</td>
                              <td>{session.date}</td>
                              <td>{session.description}</td>
                              <td>
                                <button
                                  onClick={() =>
                                    openEditSession(course.id, session)
                                  }
                                >
                                  <IoCreateOutline />
                                </button>
                                <button
                                  className="delete-btn"
                                  onClick={() =>
                                    deleteSession(course.id, session.id)
                                  }
                                  style={{ marginLeft: "10px" }}
                                >
                                  <IoTrashOutline />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {/* ===============================
          MODAL (ADD / EDIT SESSION)
      =============================== */}
      {modalOpen && (
        <div
          className="video-modal-overlay"
          onClick={() => setModalOpen(false)}
        >
          <div
            className="video-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="video-modal-header">
              <IoCloseOutline
                size={28}
                style={{ cursor: "pointer" }}
                onClick={() => setModalOpen(false)}
              />
            </div>
            <h3>{editingSession ? "Edit Session" : "Add Session"}</h3>
            <input
              type="text"
              placeholder="Session Title"
              value={sessionForm.title}
              onChange={(e) =>
                setSessionForm({ ...sessionForm, title: e.target.value })
              }
            />
            <input
              type="date"
              placeholder="Date"
              value={sessionForm.date}
              onChange={(e) =>
                setSessionForm({ ...sessionForm, date: e.target.value })
              }
            />
            <textarea
              placeholder="Description"
              value={sessionForm.description}
              onChange={(e) =>
                setSessionForm({ ...sessionForm, description: e.target.value })
              }
            />
            <div style={{ marginTop: "10px" }}>
              <button onClick={handleSaveSession}>
                {editingSession ? "Update" : "Create"}
              </button>
              <button
                style={{ marginLeft: "10px" }}
                onClick={() => setModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TPractice;
